module.exports = __webpack_public_path__ + "static/media/product-loading.236f6236.svg";